"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.promise");

require("core-js/modules/web.dom.iterable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// 内存缓存
// 作为第一级缓存 存取快 操作简单 存储量大
// 主要存储在浏览器运行这一段时间所有的异常数据 最大可能避免重复数据上报
var MemoryBuffer =
/*#__PURE__*/
function () {
  function MemoryBuffer() {
    _classCallCheck(this, MemoryBuffer);

    // 数据缓存
    this.data = []; // 是否初始化缓存

    this.hasInitData = false; // getAll执行队列

    this.todoGetAll = [];
  } // 用于初始化同步本地数据


  _createClass(MemoryBuffer, [{
    key: "initData",
    value: function initData(data) {
      var _this = this;

      var fixData = Array.isArray(data) ? data : [];
      this.data = fixData;
      this.hasInitData = true;
      this.todoGetAll.forEach(function (fn) {
        return fn(_this.data);
      });
      this.todoGetAll = null;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      // 因为IndexDB的异步操作
      // 所以要保证initData先于getAll调用
      // 同样 维护一个执行队列
      return new Promise(function (resolve) {
        if (_this2.hasInitData) {
          resolve(_this2.data);
        } else {
          _this2.todoGetAll.push(resolve);
        }
      });
    }
  }, {
    key: "addData",
    value: function addData(data) {
      return this.data.push(data);
    }
  }]);

  return MemoryBuffer;
}();

var _default = MemoryBuffer;
exports.default = _default;